export default "__VITE_ASSET__yN_qOR$b__"